import { Component, type OnInit, inject, input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'dpqa-re-route',
  standalone: true,
  imports: [],
  template: '',
})
export class ReRouteComponent implements OnInit {
  private router = inject(Router);

  public route = input<string>();

  ngOnInit(): void {
    this.router.navigate([this.route() ? this.route() : '/tenants'], {
      queryParamsHandling: 'merge',
      queryParams: { route: undefined },
      replaceUrl: true,
    });
  }
}
